module.exports = __webpack_public_path__ + "src/assets/img/icon-bag.98f760ef.svg";